import { Stack } from 'expo-router';

export const unstable_settings = {
  initialRouteName: '[type]/[token]',
};

export default function JoinLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
